import { render } from "./HomePoligon.vue?vue&type=template&id=3f8c3f48&scoped=true"
import script from "./HomePoligon.vue?vue&type=script&lang=js"
export * from "./HomePoligon.vue?vue&type=script&lang=js"

import "./HomePoligon.vue?vue&type=style&index=0&id=3f8c3f48&scoped=true&lang=css"

import exportComponent from "/home/le01s/projects/amlogger/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8c3f48"]])

export default __exports__